export default "__VITE_ASSET__dfbda385__"